import src from "./scentbird-select-logo.png";
export default { src: src, aspect: 4.305882352941176 };